export default {
    loadError: 'This section could not be loaded. Try again later.',
    noCurrentProfile: 'No competency profile is assigned to you yet.',
    strengths: {
        title: 'You excel at…',
        empty: 'Your mastered competencies will appear here once an assessment confirms them.',
    },
    evolution: {
        title: 'Your evolution journey',
        subtitle: 'See your level of mastery and the competencies to improve.',
        profileSwitch: 'Profile shown',
        currentProfile: 'Current profile',
        desiredProfile: 'Desired profile',
        currentSkillsTitle: 'Competencies expected in your current position',
        desiredSkillsTitle: 'Competencies required to reach the next level',
        noDesiredProfile: 'No desired profile is defined for you yet.',
        noSkills: 'This profile has no competency yet.',
        allReached: 'Every competency of the desired profile meets the required level.',
    },
    firstEvaluation: {
        title: 'Your levels will appear after your first assessment',
        subtitle: 'Your {{managerLabel}} has not assessed your competencies yet',
        awaitedProfileSubtitle:
            'Your {{managerLabel}} has not defined the competency profile of your position yet',
        steps: {
            ariaLabel: 'What leads to your first levels',
            profile: 'Competency profile assigned',
            awaitedProfile: 'Competency profile',
            awaitedProfileOwner: 'defined by your {{managerLabel}}',
            evaluation: 'Assessment by your {{managerLabel}}',
            levels: 'Your levels',
            levelsTiming: 'after the assessment',
        },
    },
    withheldLevels: {
        title: 'Your levels will appear after your meeting',
        subtitle:
            'Your competency picture will appear after the meeting with your {{managerLabel}}',
        notice: 'A more recent assessment has been completed and the results will appear after your meeting with your {{managerLabel}}.',
        steps: {
            ariaLabel: 'What leads to your levels',
            submitted: 'Assessment submitted',
            meeting: 'Meeting with your {{managerLabel}}',
            levels: 'Your levels',
            levelsTiming: 'after the meeting',
        },
    },
};
